export const isValidUrl = (url: string): boolean => {
  if (!url || typeof url !== 'string') return false

  try {
    new URL(url)

    return true
  } catch {
    return false
  }
}

export const sanitizeFileName = (fileName: string): string => {
  if (!fileName || typeof fileName !== 'string') return 'file'

  return fileName.replace(/[<>:"/\\|?*\x00-\x1F]/g, '').slice(0, 255)
}
